import { render, staticRenderFns } from "./purchasingAdd.vue?vue&type=template&id=2f376019&scoped=true"
import script from "./purchasingAdd.vue?vue&type=script&lang=js"
export * from "./purchasingAdd.vue?vue&type=script&lang=js"
import style0 from "./purchasingAdd.vue?vue&type=style&index=0&id=2f376019&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f376019",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/Prod-五域创客/jh-5eck-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f376019')) {
      api.createRecord('2f376019', component.options)
    } else {
      api.reload('2f376019', component.options)
    }
    module.hot.accept("./purchasingAdd.vue?vue&type=template&id=2f376019&scoped=true", function () {
      api.rerender('2f376019', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/pages/purchasingManagement/purchasingAdd.vue"
export default component.exports